<template>
  <div class="html-content">
    <h1>개인정보처리방침</h1>
    <div v-html="privateTerms" />
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'terms'
})

const PRIVACY_TERMS_ID = 'D499BAC4-2833-F111-9A49-6045BD443A50'

const { getTermsById } = useApi()
const { data: termsData } = await useAsyncData('private-policy', () =>
  getTermsById(PRIVACY_TERMS_ID)
)

const privateTerms = computed(() => termsData.value?.data?.content ?? '')
</script>

<style scoped lang="scss">
.html-content {
  h1 {
    margin-bottom: 36px;
  }
  a {
    display: block;
    text-decoration: underline;
  }
}
</style>
